export * from './error';
export * from './user-notification-dialog';
export * from './user-dialog';

import { ErrorComponents } from './error';
import { UserNotificationDialogComponents } from './user-notification-dialog';
import { UserDialogComponents } from './user-dialog';

export const AppCommonComponents = [
    ...ErrorComponents, ...UserNotificationDialogComponents, ...UserDialogComponents
];